
import { defineComponent,ref,Ref,ComputedRef,reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { UnlockOutlined, CheckCircleOutlined } from '@ant-design/icons-vue'

import { Props, validateInfos } from 'ant-design-vue/lib/form/useForm'
import { message, Form } from 'ant-design-vue'
const useForm = Form.useForm

import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'

import {SetPasswordParamsType} from './data.d'
import { StateType as updatePasswordStateType} from './store'
import { isPassword } from '@/utils/validate'



interface PasswordSetupData{
    t: (key: string | number) => string
    showflag: Ref<boolean>
    count: Ref<number>
    validateInfos: ComputedRef<validateInfos>
    modelRef: SetPasswordParamsType
    handleCtrl: (e: MouseEvent) => void
    handleLogin: (e: MouseEvent) => void
    handleSubmit: (e: MouseEvent) => void
}

export default defineComponent({
    name: 'Password',
    emits: ['update:visible'],
    components: {UnlockOutlined,CheckCircleOutlined},
    setup(_,{emit}): PasswordSetupData{
        const { t } = useI18n()
        const router = useRouter()
        const store = useStore<{updatePassword:updatePasswordStateType}>()
        const showflag = ref<boolean>(true)
        const count = ref<number>(3)
        const handleCtrl = (e: MouseEvent)=>{
            emit('update:visible',false)
        }
        const handleLogin = (e: MouseEvent) => {
            router.replace('/user/login')
        }

        const modelRef = reactive<SetPasswordParamsType>({
            password: '',
            newPassword: '',
            newPassword2: ''
        })
        const rulesRef = reactive({
            password: [
                {
                    required: true,
                    message: '请输入原密码',
                }
            ],
            newPassword: [
                {
                    required: true,
                    validator: (rule: any, value: string, callback: any)=>{
                        if(value == '' || value == undefined){
                            return Promise.reject('请输入新密码')
                        }else if(!isPassword(value)){
                            return Promise.reject('密码为6-20位大小写字母、数字或符号的至少两种组合的密码')
                        }else{
                            return Promise.resolve()
                        }
                    }
                }
            ],
            newPassword2: [
                {
                    required: true,
                    validator: (rule: any, value: string, callback: any)=>{
                        if(value == '' || value == undefined){
                            return Promise.reject('请输入新密码')
                        }else if(!isPassword(value)){
                            return Promise.reject('密码为6-20位大小写字母、数字或符号的至少两种组合的密码')
                        }else if(value && modelRef.newPassword && value !== modelRef.newPassword){
                            return Promise.reject('设置新密码与确认新密码不一致，请重新输入!')
                        }else{
                            return Promise.resolve()
                        }
                    }
                }
            ],
        })

        // 获取表单内容
        const { validate, validateInfos } = useForm(modelRef, rulesRef)

        const handleSubmit = async(e: MouseEvent) => {
            try {
                const fieldsValue = await validate<SetPasswordParamsType>()
                const email = JSON.parse(String(localStorage.getItem('userMsg'))).email
                const data = {
                    password: fieldsValue.password,
                    newPassword: fieldsValue.newPassword,
                    newPassword2: fieldsValue.newPassword2,
                    username: email
                }
                const res:boolean = await store.dispatch('updatePassword/updatePasswordFn',data)
                if(res === true){
                    showflag.value = false
                    const time = setInterval(()=>{
                        if(count.value <= 0){
                            clearInterval(time)
                            router.replace('/user/login')
                        }else{
                            count.value--
                        }
                    },1000)
                }
            } catch (error) {
                message.warning('修改密码失败!')
            }

        }

        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        return {
            t,
            showflag,
            count,
            modelRef,
            validateInfos:validateInfosNew,
            handleCtrl,
            handleLogin,
            handleSubmit
        }
    }
})
